module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.e4ee99e3.svg";